export const isLegacyCrmEnabled =
  String(process.env.REACT_APP_ENABLE_LEGACY_CRM || "").toLowerCase() === "true";
